import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import { init } from '@sentry/vue';
import {
  AlertPlugin,
  BadgePlugin,
  ButtonPlugin,
  ButtonGroupPlugin,
  CardPlugin,
  CollapsePlugin,
  DropdownPlugin,
  FormCheckboxPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  ImagePlugin,
  InputGroupPlugin,
  LayoutPlugin,
  ListGroupPlugin,
  ModalPlugin,
  NavPlugin,
  PaginationPlugin,
  ProgressPlugin,
  PopoverPlugin,
  SpinnerPlugin,
  TablePlugin,
  TabsPlugin,
  TooltipPlugin,
  OverlayPlugin,
} from 'bootstrap-vue';
import VueRouter from 'vue-router';
import Multiselect from 'vue-multiselect';
import VueScrollTo from 'vue-scrollto';
import VueSlider from 'vue-slider-component';
import BUILD_VERSION from './BuildVersion';
import LoadingMask from './common/loadingMask/LoadingMask';

Vue.use(VueCustomElement);

// BootstrapVue
Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(CardPlugin);
Vue.use(CollapsePlugin);
Vue.use(DropdownPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(ImagePlugin);
Vue.use(InputGroupPlugin);
Vue.use(LayoutPlugin);
Vue.use(ListGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(NavPlugin);
Vue.use(PaginationPlugin);
Vue.use(ProgressPlugin);
Vue.use(PopoverPlugin);
Vue.use(SpinnerPlugin);
Vue.use(TablePlugin);
Vue.use(TabsPlugin);
Vue.use(TooltipPlugin);
Vue.use(OverlayPlugin);

Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.component('Multiselect', Multiselect);
Vue.component('VueSlider', VueSlider);
Vue.directive('loading', LoadingMask);

if (process.env.NODE_ENV === 'production') {
  init({
    async beforeSend(event) {
      const isSourceLocalWebpage = event.request.url.startsWith('file://');
      if (isSourceLocalWebpage) {
        return null;
      }
      const { default: { userId } } = await import('./VcomProvider');
      if (userId !== null) {
        /* eslint-disable-next-line no-param-reassign */
        event.user = { id: `${userId}` };
      }
      return event;
    },
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    dsn: 'https://3148081529aa444ea5139109aa25e9fa@o154513.ingest.sentry.io/1211209',
    Vue,
    attachProps: true,
    release: BUILD_VERSION,
  });
} else {
  Vue.config.performance = true;
  Vue.config.productionTip = false;
}
